/**
 * UI-side mirror of PermissionNames.cs in the API.
 * Use these constants as arguments to AuthService.hasNamedPermission() instead of hard-coded strings.
 * The hierarchy represents {Area or Entity}.{Optional Sub-Entity}.{Action}.
 */
export const PermissionNames = {
  Profile: {
    Read: 'Profile.Read',
    Capacity: {
      Read: 'Profile.Capacity.Read',
      Write: 'Profile.Capacity.Write',
    },
  },

  Clients: {
    Read: 'Clients.Read',
  },

  Matters: {
    Read: 'Matters.Read',
    Write: 'Matters.Write',
  },

  Resources: {
    Read: 'Resources.Read',
    Write: 'Resources.Write',
    Capacity: {
      Read: 'Resources.Capacity.Read',
      Write: 'Resources.Capacity.Write',
    },
    TimeOff: {
      Read: 'Resources.TimeOff.Read',
      Write: 'Resources.TimeOff.Write',
      Approval: 'Resources.TimeOff.Approval',
    },
    TimeOffPolicy: {
      Write: 'Resources.TimeOffPolicy.Write',
    },
  },

  Requests: {
    Read: 'Requests.Read',
    Create: 'Requests.Create',
    Edit: 'Requests.Edit',
  },

  Assignments: {
    Create: 'Assignments.Create',
    Delete: 'Assignments.Delete',
    Edit: 'Assignments.Edit',
    ManagerNotes: {
      Read: 'Assignments.ManagerNotes.Read',
      Write: 'Assignments.ManagerNotes.Write',
    },
    ResourceNotes: {
      Read: 'Assignments.ResourceNotes.Read',
    },
  },

  Admin: {
    UserManagement: {
      Read: 'Admin.UserManagement.Read',
      Write: 'Admin.UserManagement.Write',
    },
    SuperAdminManagement: {
      Allow: 'Admin.SuperAdminManagement.Allow',
    },
    Permissions: {
      Read: 'Admin.Permissions.Read',
      Write: 'Admin.Permissions.Write',
    },
    PracticeArea: {
      Read: 'Admin.PracticeArea.Read',
      Write: 'Admin.PracticeArea.Write',
    },
    SecondaryOffices: {
      Read: 'Admin.SecondaryOffices.Read',
      Write: 'Admin.SecondaryOffices.Write',
    },
    AuditHistory: {
      Read: 'Admin.AuditHistory.Read',
    },
    UserFeedback: {
      Read: 'Admin.UserFeedback.Read',
    },
    SystemLogs: {
      Read: 'Admin.SystemLogs.Read',
    },
    AppSettings: {
      Read: 'Admin.AppSettings.Read',
      Write: 'Admin.AppSettings.Write',
    },
    FeatureFlags: {
      Read: 'Admin.FeatureFlags.Read',
      Write: 'Admin.FeatureFlags.Write',
    },
    TimeOffPolicy: {
      Read: 'Admin.TimeOffPolicy.Read',
      Write: 'Admin.TimeOffPolicy.Write',
    },
    OfficeNotifications: {
      Read: 'Admin.OfficeNotifications.Read',
      Write: 'Admin.OfficeNotifications.Write',
    },
    OfficePracticeAreaSettings: {
      Read: 'Admin.OfficePracticeAreaSettings.Read',
      Write: 'Admin.OfficePracticeAreaSettings.Write',
    },
  },

  System: {
    HardDelete: 'System.HardDelete',
    DataSeeder: 'System.DataSeeder',
  },
} as const;
